export default "__VITE_ASSET__DrxQGno2__"